import React from 'react';
import { FC } from 'react';

export const Problems: FC = () => {
    const style = {
        marginTop: '7rem'
    };
    const style1 = {
        marginTop: '47rem'
    };
    return (
        <main>
            <div className='center' style={ style1 }>
                WIP
            </div>   
        </main>
    )
};
